import { render, staticRenderFns } from "./HtmlEditorTiptapToolbar.vue?vue&type=template&id=4f4d448e&"
import script from "./HtmlEditorTiptapToolbar.vue?vue&type=script&lang=js&"
export * from "./HtmlEditorTiptapToolbar.vue?vue&type=script&lang=js&"
import style0 from "./HtmlEditorTiptapToolbar.vue?vue&type=style&index=0&id=4f4d448e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports